import { gql } from '@apollo/client';

export default gql`
  query getProjects($isRTL: Boolean, $status: Int, $calc: Boolean) {
    getProjects(isRTL: $isRTL, status: $status, calc: $calc) {
      ok
      error
      data {
        _id
        branch
        autoNo
        docNo
        disabled
        additionId
        name
        nameAr
        color

        type
        start
        end
        location {
          lat
          lng
        }
        priority
        status

        desc

        total
        discount
        amount
        totalinvoiced
        totalDiscount
        totalPurchaseInvoiced
        totalPurchasePaid
        totalPurchaseDiscount
        toatlProdExpenses
        totalpaid
        toatlExpenses
        totalkaidsdebit
        totalKaidscredit
        balance

        progress
        evQty
        evDone

        customerId
        customerName
        customerNameAr
        customerPhone

        departmentId
        departmentName
        departmentNameAr
        departmentColor

        employeeId
        employeeName
        employeeNameAr
        employeeColor
        employeePhone

        resourseId
        resourseName
        resourseNameAr
        resourseColor

        userId

        createdAt
        updatedAt
      }
    }
  }
`;
